import { CustomYup } from 'validations/CustomYup'

const importTasksSchema = CustomYup.object().shape({
  file: CustomYup.mixed().required('Plik jest wymagany'),
  publishedAt: CustomYup.string().nullable(),
})

export default importTasksSchema
